import { render, staticRenderFns } from "./StatisticsCardLine.vue?vue&type=template&id=894cbf48&"
import script from "./StatisticsCardLine.vue?vue&type=script&lang=js&"
export * from "./StatisticsCardLine.vue?vue&type=script&lang=js&"
import style0 from "./StatisticsCardLine.vue?vue&type=style&index=0&id=894cbf48&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports